import { useState } from "react";
import { FaThLarge, FaListUl } from "react-icons/fa";
import { FilesTable } from "./files-table";
import FilesImg from "../../assets/files.png";
import GoogleDocs from "../../assets/Google docs.png";
import { Link } from "react-router-dom";

// const files = [
//   {
//     id: 1,
//     title: "Data Privacy & Security Policies",
//     author: "Catherine Jacobs",
//     date: "26/03/2024",
//   },
//   {
//     id: 2,
//     title: "Employee Guidelines",
//     author: "Michael Ross",
//     date: "18/04/2024",
//   },
//   {
//     id: 3,
//     title: "Annual Report 2024",
//     author: "Sarah Cole",
//     date: "21/05/2024",
//   },
//   // add more as needed...
// ];

const files = [
  {
    id: 1,
    name: "Data Privacy Policy.doc",
    image: FilesImg,
    owner: "Cheryl Temioluwa",
    createdOn: "17th March, 2025",
    lastModified: "17th March, 2025",
    modifiedBy: "Cheryl Temioluwa",
  },
  {
    id: 2,
    name: "Data Privacy Policy.doc",
    image: FilesImg,
    owner: "Cheryl Temioluwa",
    createdOn: "17th March, 2025",
    lastModified: "17th March, 2025",
    modifiedBy: "Cheryl Temioluwa",
  },
  {
    id: 3,
    name: "Data Privacy Policy.doc",
    image: FilesImg,
    owner: "Cheryl Temioluwa",
    createdOn: "17th March, 2025",
    lastModified: "17th March, 2025",
    modifiedBy: "Cheryl Temioluwa",
  },
];

const boards = [
  {
    id: 1,
    image: GoogleDocs,
    name: "Data Privacy & Security Policies",
    owner: "Catherine Jacobs",
    dateCreated: "26/03/2024",
  },
  {
    id: 2,
    image: GoogleDocs,
    name: "Data Privacy & Security Policies",
    owner: "Catherine Jacobs",
    dateCreated: "26/03/2024",
  },
  {
    id: 3,
    image: GoogleDocs,
    name: "Data Privacy & Security Policies",
    owner: "Catherine Jacobs",
    dateCreated: "26/03/2024",
  },
  {
    id: 4,
    image: GoogleDocs,
    name: "Data Privacy & Security Policies",
    owner: "Catherine Jacobs",
    dateCreated: "26/03/2024",
  },
  {
    id: 5,
    image: GoogleDocs,
    name: "Data Privacy & Security Policies",
    owner: "Catherine Jacobs",
    dateCreated: "26/03/2024",
  },
];

export default function OpenFolderPage() {
  const [view, setView] = useState("board");

  return (
    <div className="font-Outfit min-h-screen">
      <div className="p-6">
        <div className="flex justify-between  items-center mb-6">
          <div className=" flex space-x-2">
            <h1 className="text-2xl font-semibold">Documents</h1>
            <Link to="/employee">
              <div className="px-3 py-1 border-[#3C60FFB2] border rounded-lg">
                <span className="text-sm text-black">Assets</span>
              </div>
            </Link>
          </div>

          <button className="bg-blue-600 text-white px-4 py-2 rounded-lg text-sm font-medium">
            Add new
          </button>
        </div>

        <div className="flex justify-between items-center mb-6">
          <h2 className="text-lg font-medium">All Files</h2>
          <div className="flex items-center gap-3">
            <button
              onClick={() => setView("board")}
              className={`flex items-center gap-2 border px-3 py-1.5 rounded-md text-sm ${
                view === "board"
                  ? "bg-gray-900 text-white"
                  : "bg-white text-gray-700"
              }`}
            >
              <FaThLarge /> Board View
            </button>
            <button
              onClick={() => setView("list")}
              className={`flex items-center gap-2 border px-3 py-1.5 rounded-md text-sm ${
                view === "list"
                  ? "bg-gray-900 text-white"
                  : "bg-white text-gray-700"
              }`}
            >
              <FaListUl /> List View
            </button>
          </div>
        </div>

        {view === "board" ? (
          <div>
            {/* {files.map((file) => (
              <div
                key={file.id}
                className="p-4 border rounded-xl bg-white hover:shadow-md transition"
              >
                <div className="flex flex-col">
                  <div className="flex-1">
                    <h3 className="text-base font-semibold text-gray-800">
                      {file.title}
                    </h3>
                    <p className="text-sm text-gray-500 mt-2">{file.author}</p>
                  </div>
                  <p className="text-xs text-gray-400 mt-3">{file.date}</p>
                </div>
              </div>
            ))} */}

            <FilesTable
              files={files}
              boards={boards}
            />
          </div>
        ) : (
          <div className="bg-white rounded-xl border overflow-hidden">
            <table className="w-full text-sm text-left">
              <thead className="bg-gray-50 border-b">
                <tr>
                  <th className="px-4 py-3 font-medium text-gray-600">Title</th>
                  <th className="px-4 py-3 font-medium text-gray-600">
                    Author
                  </th>
                  <th className="px-4 py-3 font-medium text-gray-600">Date</th>
                </tr>
              </thead>
              <tbody>
                {files.map((file) => (
                  <tr
                    key={file.id}
                    className="border-b hover:bg-gray-50 transition"
                  >
                    <td className="px-4 py-3">{file.title}</td>
                    <td className="px-4 py-3 text-gray-600">{file.author}</td>
                    <td className="px-4 py-3 text-gray-500">{file.date}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
